import Delegate from "//okr-qa.ovh/cdn/shop/t/2/assets/ftdomdelegate.min.js?v=85864865866317895671655307500";
export class TestCureSection extends HTMLElement {

  connectedCallback() {
    this._attachListeners();
  }

  _attachListeners() {
    new Delegate(this).on('click', '[data-action="test-cure"]', this._formCure.bind(this));
    new Delegate(this).on('click', '[data-action="test-cure-return"]', this._formCureReturn.bind(this));
  }

  _formCure(event) {
    event.preventDefault();

    let formCure            = this.querySelector('.test-cure--form');
    let resultCure          = this.querySelector('.test-cure--result');
    let inputType           = this.querySelector('input[name="type"]:checked');
    let inputHeight         = this.querySelector('.input-height');
    let inputCurrentWeight  = this.querySelector('.input-current_weight');
    let inputWeightGoal     = this.querySelector('.input-weight_goal');
    let inputAge            = this.querySelector('.input-age');
    //let inputActivity       = this.element.querySelector('.input-activity');

    if (inputType) inputType = inputType.value;
    if (inputHeight) inputHeight = inputHeight.value / 100;
    if (inputCurrentWeight) inputCurrentWeight = inputCurrentWeight.value;
    if (inputWeightGoal) inputWeightGoal = inputWeightGoal.value;
    if (inputAge) inputAge = inputAge.value;
    //if (inputActivity) inputActivity = parseInt(inputActivity.options[inputActivity.selectedIndex].value);

    let iMc                 = (inputCurrentWeight / (inputHeight * inputHeight)).toFixed(2);
    let iMcGoal             = (inputWeightGoal / (inputHeight * inputHeight)).toFixed(2);
    let weightLose          = inputCurrentWeight - inputWeightGoal;
    let isValidForm         = true;

    let errorType           = this.querySelector('[data-error="type"]');
    let errorHeight         = this.querySelector('[data-error="height"]');
    let errorCurrentWeight  = this.querySelector('[data-error="current-weight"]');
    let errorWeightGoal     = this.querySelector('[data-error="goal-weight"]');
    let errorAge            = this.querySelector('[data-error="age"]');
    //let errorActivity       = this.element.querySelector('[data-error="activity"]');

    // gender input
    if (inputType == null) {
      errorType.classList.add('active');
      isValidForm = false;
    } else {
      errorType.classList.remove('active');
    }

    // height input
    if (inputHeight <= 0) {
      errorHeight.classList.add('active');
      isValidForm = false;
    } else {
      errorHeight.classList.remove('active');
    }

    // current weight input
    if (inputCurrentWeight === "" || inputCurrentWeight < 50) {
      errorCurrentWeight.classList.add('active');
      isValidForm = false;
    } else {
      errorCurrentWeight.classList.remove('active');
    }

    // weight goal input
    if (inputWeightGoal === "" || inputWeightGoal < 50) {
      errorWeightGoal.classList.add('active');
      isValidForm = false;
    } else {
      errorWeightGoal.classList.remove('active');
    }

    // input age
    if (inputAge === "") {
      errorAge.classList.add('active');
      isValidForm = false;
    } else {
      errorAge.classList.remove('active');
    }

    // input activity
    // if (inputActivity === 0) {
    //   errorActivity.classList.add('active');
    //   isValidForm = false;
    // } else {
    //   errorActivity.classList.remove('active');
    // }

    if (isValidForm) {

      /** LOADER */
      let range        = 0;
      let result       = 0;
      let resultProd   = 0;

      if (iMc < 18.5) {
        range = 1;
      } else if (iMc < 25.1){
        range = 2;
      } else if (iMc < 30.1){
        range = 3;
      } else {
        range = 4;
      }

      if (weightLose < 2.1) {
        result = 1;
        resultProd = 0;
      } else if (weightLose < 3.6) {
        result = 2;
        resultProd = 1;
      } else if (weightLose < 7.1) {
        result = 3;
        resultProd = 2;
      } else {
        result = 4;
        resultProd = 2;
      }

      if (iMc < 18.5) {
        result = 5;
        resultProd = 3;
      }

      // display first paragraph
      for (let i = 1; i < 5; i++) {
        if (window.theme.testCure['range'+range]['text'+i]) {
          this._constructResult('range'+i,window.theme.testCure['range'+range]['text'+i],iMc)
        }
      }

      // display product paragraph
      for (let i = 1; i < 6; i++) {
        if (window.theme.testCure['result'+result]['text'+i]) {
          this._constructResult('result'+i,window.theme.testCure['result'+result]['text'+i],iMc)
        }
      }

      // display product result
      let productCure = this.querySelector('.product-item__wrapper_'+resultProd);
      if (productCure) productCure.classList.add('active');


      if ( iMcGoal > 18.4 ) {
        let textRange4 = this.querySelector('.test-cure--range4');
        textRange4.classList.remove('active');
      }

      let buttonLoading  = this.querySelector('.button-loading');
      let formLoading    = this.querySelector('.test-cure--form-loading');

      buttonLoading.classList.add('is-loading');
      formLoading.classList.add('is-loading');

      setTimeout(function() {
        formCure.classList.add('disabled');
        resultCure.classList.add('active');
      }, 1000)
    }
  }

  _constructResult(pContainer, text, iMc) {
    let textResult = this.querySelector('.test-cure--' + pContainer);
    if (pContainer === 'range1') {
      textResult.innerHTML = text + " <p class='h2'>" + iMc + "</p>";
    } else {
      textResult.innerHTML = text;
    }
    textResult.classList.add('active');
  }

  _formCureReturn(event) {
    event.preventDefault();

    let testCureText = this.querySelectorAll(".test-cure--text");
    let testCureProd = this.querySelectorAll(".product-item__wrapper");

    for (let i = 0; i < testCureText.length; i++) {
      testCureText[i].classList.remove('active');
    }

    for (let i = 0; i < testCureProd.length; i++) {
      testCureProd[i].classList.remove('active');
    }

    let buttonLoading  = this.querySelector('.button-loading');
    let formLoading    = this.querySelector('.test-cure--form-loading');
    let formCure       = this.querySelector('.test-cure--form');
    let resultCure     = this.querySelector('.test-cure--result');

    buttonLoading.classList.remove('is-loading');
    formLoading.classList.remove('is-loading');
    formCure.classList.remove('disabled');
    resultCure.classList.remove('active');

    // reset inputs
    let inputType           = this.querySelector('input[name="type"]');
    let inputHeight         = this.querySelector('.input-height');
    let inputCurrentWeight  = this.querySelector('.input-current_weight');
    let inputWeightGoal     = this.querySelector('.input-weight_goal');
    let inputAge            = this.querySelector('.input-age');
    //let inputActivity       = this.element.querySelector('.input-activity');

    if (inputType) inputType.checked = false;
    if (inputHeight) inputHeight.value = '';
    if (inputCurrentWeight) inputCurrentWeight.value = '';
    if (inputWeightGoal) inputWeightGoal.value = '';
    if (inputAge) inputAge.value = '';
    //if (inputActivity) inputActivity.value = 0;

  }

}
try {
  window.customElements.define('test-cure-section', TestCureSection);
} catch(e) {}